import { BoxList, StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { DocumentStatuses } from 'modules/documents/lib/enums'
import type Log from 'modules/documents/store/models/Log'

interface Props {
  document: Document
  statusChangedLog: Log | undefined
}

const Status = ({ document, statusChangedLog }: Props) => {
  const employee = document.employee
  const ownerFullname = employee ? employee.fullName : ''
  const access = users.get(employee?.accessId)
  const avatar = access?.avatar

  const stringToDocumentStatus = (status: string | null | undefined): DocumentStatuses => {
    if (status != DocumentStatuses.ToFill && status != DocumentStatuses.ToFill)
      return DocumentStatuses.Filled

    return {
      to_fill: DocumentStatuses.ToFill,
      filled: DocumentStatuses.Filled,
    }[status]
  }

  const toStatusStruct = (doc: Document): StatusStruct => {
    return {
      signerFullName: ownerFullname,
      signerAvatar: (employee && avatar) || '',
      statusText: getStatusText(stringToDocumentStatus(doc.status)),
      statusDate: statusChangedLog?.attributes.created_at,
    }
  }

  const getTagColor = (status: DocumentStatuses): StatusLabelTypes => {
    if (DocumentStatuses.ToFill === status) return 'warning'
    if (DocumentStatuses.Filled === status) return 'positive'

    return 'info'
  }

  const getStatusText = (status: DocumentStatuses): string => {
    return {
      [DocumentStatuses.ToFill]: i18n.t('documents.modal.fillable.status.to_fill'),
      [DocumentStatuses.Filled]: i18n.t('documents.modal.fillable.status.filled'),
    }[status]
  }

  return (
    <BoxList>
      <StatusItem
        status={toStatusStruct(document)}
        statusBox={
          <StatusLabel ellipsis type={getTagColor(stringToDocumentStatus(document.status))}>
            {getStatusText(stringToDocumentStatus(document.status))}
          </StatusLabel>
        }
      />
    </BoxList>
  )
}

export default Status
